export const NAME = 'staticSite';
export const FORM_NAME = 'siteForm';
export const SHAPE_NAME = 'TSStaticSite';
export const SHAPE_ID = 'SITE';
export const SITE_SEARCH_NAME = 'TSStaticSiteList';
